import { createJsonNormalizer, createShapeNormalizer } from '@change-corgi/config/fcm/normalizers';
import { getLocales } from '@change-corgi/config/locales';

import { createFcmConfig } from '../shared/factory';

const normalizer = createShapeNormalizer({
	type: 'record',
	keys: getLocales(),
	shape: { type: 'boolean', optional: true },
});

export const FCM_PACIFIC_NEW_PETITION_EDIT_PAGE = createFcmConfig('pacific_new_petition_edit_page', {
	normalizer: createJsonNormalizer(normalizer),
	defaultValue: {} as ReturnType<typeof normalizer>,
});
